<template>
  <div>
    <section>
      <div class="bg container-fluid d-flex justify-content-center flex-column">
        <!-- header -->
        <div class="text-center">
          <h3 class="m-5">ขอขอบคุณ</h3>
        </div>

        <!-- body -->
        <div class="row mb-5">
          <div class="col-lg-4 col-md-5 text-center">
            <p class="b4">ข้อมูลจาก</p>
          </div>

          <div class="alltext ol-lg-5 col-md-6">
            <ul>
              <!-- <li class="b5" v-for="(item, index) in nameweb" :key="index">
                {{ item }}
              </li> -->
              <a href="https://www.flandersinvestmentandtrade.com/export/sites/trade/files/market_studies/Studie%20Beer%20Market%20in%20Thailand.pdf" target="_blank"><li class="b5">BEER MARKET IN THAILAND</li></a>
              <a href="https://beerforjane.wordpress.com/" target="_blank"><li class="b5">Jane's Beer Blog</li></a>
              <a href="https://www.thedrinksbusiness.com/2022/05/top-10-biggest-beer-producing-countries/" target="_blank"
                ><li class="b5">Top 10 biggest beer producing countries</li></a
              >
              <a href="https://justbeerapp.com/article/beer-styles" target="_blank"
                ><li class="b5">
                  Types of Beer: A Guide & List to Different Styles
                </li></a
              >
              <a href="https://cas.or.th/cas/wp-content/uploads/2019/07/43.-60-AC-0005-Craft-Beer-final-.pdf" target="_blank"><li class="b5">คราฟต์เบียร์ในสังคมไทย</li></a>
              <a href="https://craftnroll.net/uncategorized/beer-101-ale-lager-%e0%b9%80%e0%b8%ad%e0%b8%a5-%e0%b8%81%e0%b8%b1%e0%b8%9a-%e0%b8%a5%e0%b8%b2%e0%b9%80%e0%b8%81%e0%b8%ad%e0%b8%a3%e0%b9%8c/" target="_blank"
                ><li class="b5">
                  บทความ “BEER BASIC 101 – Ale or Lager…what?
                  …มารู้จักเบียร์กันดีกว่า ตอน: เอล กับ ลาเกอร์
                </li></a
              >
              <a href="https://craftnroll.net/uncategorized/%E0%B9%80%E0%B8%9A%E0%B8%B5%E0%B8%A2%E0%B8%A3%E0%B9%8C-%E0%B8%97%E0%B8%B3%E0%B8%88%E0%B8%B2%E0%B8%81%E0%B8%AD%E0%B8%B0%E0%B9%84%E0%B8%A3/" target="_blank"
                ><li class="b5">
                  บทความ “BEER BASIC 101 – The main ingredients
                  …มารู้จักเบียร์กันดีกว่า ตอน: เบียร์ ทำจากอะไร”
                </li></a
              >
              <a href="https://themomentum.co/happy-toplist-thai-craft-beer-10/" target="_blank"
                ><li class="b5">
                  บทความ “Top 10 Thai Craft Beer 10 คราฟต์เบียร์ไทยที่ใครๆ
                  ก็ไม่ควรพลาด!”
                </li></a
              >
              <a href="https://www.bltbangkok.com/news/3960/" target="_blank"
                ><li class="b5">
                  บทความ “คราฟท์เบียร์สัญชาติไทย แต่ผลิตต่างแดน”
                </li></a
              >
              <a href="https://tdri.or.th/2019/04/th-craft-beer-industry/" target="_blank"
                ><li class="b5">
                  บทความ “คราฟท์เบียร์ไทย’ เสียท่า ด้วยกติกาขัดขาตัวเอง”
                </li></a
              >
              <a href="https://workpointtoday.com/explaine-alcohol/" target="_blank"
                ><li class="b5">
                  บทความ “พ.ร.บ.ห้ามโฆษณาเหล้า-เบียร์ แบรนด์เล็กตาย
                  แบรนด์ใหญ่ไม่โต”
                </li></a
              >

              <a href="https://www.soimilk.com/nightlife/news/new-thai-craft-beers-2017" target="_blank"
                ><li class="b5">
                  บทความ “รวม 10 คราฟต์เบียร์ไทยที่เปิดตัวพร้อมๆ กันเดือนนี้”
                </li></a
              >
              <a href="https://www.matichon.co.th/entertainment/arts-culture/news_211033" target="_blank"
                ><li class="b5">
                  บทความ “ห้ามขายเหล้าวันพระใหญ่ :
                  รัฐกับข้ออ้างบนพนักพิงของศาสนา”
                </li></a
              >
              <a href="https://www.parliament.go.th/section77/manage/files/file_20200629093520_1_91.pdf" target="_blank"
                ><li class="b5">
                  ร่างพระราชบัญญัติภาษีสรรพสามิต (ฉบับที่ ..) พ.ศ. ….
                  (ร่าง พ.ร.บ.สุราก้าวหน้า)
                </li></a
              >
            </ul>
            <br />
            <p class="b5">
              และคราฟต์เบียร์ 24 แบรนด์ ดังนี้<br />D'X Brewerkz, HYENA HOWL,
              โกลเด้นคอยส์ (Golden Coins), ชางวอน เอกซ์เพรส (Changwon Express),
              เชียงใหม่ (Chiang Mai Beer), แซนด์พอร์ต (Sandport), เดอะเซอร์คัส
              (The Circus), เทพพนม (Devanom), บ้านนอกเบียร์ (Bannok Beer),
              บีทบรูวิ่ง (Beat Brewing), บูทเลก บราเธอร์ (Bootleg Brothers),
              ทริปเปิล เพิร์ล (Triple Pearl), ผีบอก (Pheebok), ฟูลมูน บริวเวิร์ก
              (Full Moon Brewwork),ภูเก็ต (Phuket Beer), มหานคร (Mahanakhon),
              ยอดเบียร์ (YodBeer), ยักษา บริวเวอรี่ (YAKSA Brewery), ลูกกรุง
              บริวว์ (Look-krung Brew), ลำซิ่ง (Lamzing), สเปซคราฟต์
              (SpaceCraft), สโตน เฮด (Stone Head), เอาท์ลอว์ (Outlaw),
              แฮปปี้นิวเบียร์ (Happy New Beer)
            </p>
            <br />
            <br />
          </div>

          <div class="col-lg-4 col-md-5 text-center">
            <p class="b4">หน่วยงานและองค์กร</p>
          </div>

          <div class="col-lg-5 col-md-6">
            <ul>
              <li class="b5" v-for="(item, index) in companies" :key="index">
                {{ item }}
              </li>
            </ul>
            <br />
            <br />
          </div>

          <div class="col-lg-4 col-md-5 text-center">
            <p class="b4">ผู้ให้สัมภาษณ์</p>
          </div>

          <div class="col-lg-5 col-md-6">
            <ul>
              <li class="b5" v-for="(item, index) in interviewee" :key="index">
                {{ item }}
              </li>
            </ul>
            <br />
            <br />
          </div>

          <div class="col-lg-4 col-md-5 text-center">
            <p class="b4">เพจ Facebook</p>
          </div>

          <div class="col-lg-5 col-md-6">
            <ul>
              <li class="b5" v-for="(item, index) in pages" :key="index">
                {{ item }}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "CreditComponent",
  data() {
    return {
      nameweb: [
        "BEER MARKET IN THAILAND",
        "Jane's Beer Blog",
        "Top 10 biggest beer producing countries",
        "Types of Beer: A Guide & List to Different Styles",
        "คราฟต์เบียร์ในสังคมไทย",
        "บทความ “BEER BASIC 101 – Ale or Lager…what? …มารู้จักเบียร์กันดีกว่า ตอน: เอล กับ ลาเกอร์”",
        "บทความ “BEER BASIC 101 – The main ingredients …มารู้จักเบียร์กันดีกว่า ตอน: เบียร์ ทำจากอะไร”",
        "บทความ “Top 10 Thai Craft Beer 10 คราฟต์เบียร์ไทยที่ใครๆ ก็ไม่ควรพลาด!”",
        "บทความ “คราฟท์เบียร์สัญชาติไทย แต่ผลิตต่างแดน”",
        "บทความ “คราฟท์เบียร์ไทย’ เสียท่า ด้วยกติกาขัดขาตัวเอง”",
        "บทความ “พ.ร.บ.ห้ามโฆษณาเหล้า-เบียร์ แบรนด์เล็กตาย แบรนด์ใหญ่ไม่โต”",
        "บทความ “รวม 10 คราฟต์เบียร์ไทยที่เปิดตัวพร้อมๆ กันเดือนนี้”",
        "บทความ “ห้ามขายเหล้าวันพระใหญ่ : รัฐกับข้ออ้างบนพนักพิงของศาสนา”",
        "ร่างพระราชบัญญัติภาษีสรรพสามิต (ฉบับที่ ..) พ.ศ. …. (ร่าง พ.ร.บ.สุราก้าวหน้า)",
      ],
      companies: [
        "BLT Bangkok",
        "FLANDERS INVESTMENT & TRADE MARKET SURVEY",
        "RateBeer",
        "The Momentum",
        "มติชนออนไลน์",
        "BLT Bangkok",
        "สถาบันวิจัยเพื่อการพัฒนาประเทศไทย (ทีดีอาร์ไอ)",
      ],
      interviewee: ["กษิดิ์พัฒน์ ศุกรสุต", "จิรภาส สระโร"],
      pages: ["แดกเบียร์ให้เพลียแคม"],
    };
  },
};
</script>

<style scoped>
.bg {
  background: #f8ef8f;
}
p {
  margin-bottom: 0;
}
a{
  text-decoration: none;
  color: black;
}
a:hover{
  color: black;
  text-decoration: underline;
}
/* mobile */
@media (max-width: 540px) {
  .b4 {
    font-size: 17px;
    margin-bottom: 2rem;
  }
  .b5 {
    /* margin: 2rem; */
    font-size: 13px;
  }
  .alltext {
    padding: 2rem;
  }
}
</style>
